import React, { useCallback, useState } from 'react';

export const FilterModalContext = React.createContext<{
    showFilter: boolean;
    openFilter: () => void;
    closeFilter: () => void;
}>({
    showFilter: false,
    openFilter: () => {
        // eslint-disable-next-line no-console
        console.log(
            'openFilter not defined, did you wrap your components like this: <FilterModalProvider>...</FilterModalProvider>',
        );
    },
    closeFilter: () => {
        // eslint-disable-next-line no-console
        console.log(
            'closeFilter not defined, did you wrap your components like this: <FilterModalProvider>...</FilterModalProvider>',
        );
    },
});

export const FilterModalProvider: React.FC<React.PropsWithChildren> = React.memo((props) => {
    const [showFilter, setShowFilter] = useState(false);
    const openFilter = useCallback(() => {
        setShowFilter(true);
        document.body.style.overflow = 'hidden';
    }, []);
    const closeFilter = useCallback(() => {
        setShowFilter(false);
        document.body.style.overflow = 'auto';
    }, []);
    return (
        <FilterModalContext.Provider value={{ showFilter, openFilter, closeFilter }}>
            {props.children}
        </FilterModalContext.Provider>
    );
});
